import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

// Import du logo
import logoImage from '../images/mon-depannage-informatique-logo.webp';

const outilsMenu = [
  {
    group: 'Communication & Collaboration',
    items: [
      { label: 'ClickMeeting', href: '/outils/videoconference/avis-clickmeeting-videoconference' },
      { label: 'Ringover', href: '/outils/telephonie/avis-ringover-telephonie' },
    ],
  },
];

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isHidden, setIsHidden] = useState(false);
  const [isOutilsOpen, setIsOutilsOpen] = useState(false);
  const location = useLocation();

  const isAffiliationPage = location.pathname.startsWith('/outils/');

  useEffect(() => {
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setIsScrolled(currentScrollY > 50);

      if (isAffiliationPage) {
        setIsHidden(currentScrollY > lastScrollY && currentScrollY > 100);
      }

      lastScrollY = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isAffiliationPage]);

  useEffect(() => {
    setIsHidden(false);
  }, [location.pathname]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''} ${isHidden ? 'header-hidden' : ''}`}>
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo" onClick={closeMenu}>
            <img 
              src={logoImage} 
              alt="Excellence Informatique - Logo" 
              className="logo-image"
            />
          </Link>

          <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
            <ul className="nav-list">
              <li className="nav-item">
                <Link 
                  to="/" 
                  className={`nav-link ${isActive('/') ? 'active' : ''}`}
                  onClick={closeMenu}
                >
                  Accueil
                </Link>
              </li>
              <li className="nav-item dropdown">
                <span className="nav-link dropdown-toggle">
                  Services
                </span>
                <ul className="dropdown-menu">
                  <li><Link to="/reparation/informatique/" onClick={closeMenu}>Réparation Informatique</Link></li>
                  <li><Link to="/reparation/pc/" onClick={closeMenu}>Réparation PC</Link></li>
                  <li><Link to="/reparation/ordinateur/" onClick={closeMenu}>Réparation Ordinateur</Link></li>
                  <li><Link to="/reparation/domicile/" onClick={closeMenu}>Réparation à Domicile</Link></li>
                  <li><Link to="/recuperation-de-donnees/" onClick={closeMenu}>Récupération de Données</Link></li>
                  <li><Link to="/micro-soudure-et-plasturgie/" onClick={closeMenu}>Micro-soudure</Link></li>
                </ul>
              </li>
              <li className="nav-item dropdown">
                <span className="nav-link dropdown-toggle">
                  Zones
                </span>
                <ul className="dropdown-menu">
                  <li><Link to="/accueil/domicile/loire-atlantique/" onClick={closeMenu}>Loire-Atlantique</Link></li>
                  <li><Link to="/accueil/domicile/ordinateur/zone/" onClick={closeMenu}>Zone d'Intervention</Link></li>
                </ul>
              </li>
              <li className="nav-item dropdown">
                <span className="nav-link dropdown-toggle">
                  Forfaits
                </span>
                <ul className="dropdown-menu">
                  <li><Link to="/accueil/domicile/ordinateur/forfaits/windows/" onClick={closeMenu}>Forfaits Windows</Link></li>
                  <li><Link to="/accueil/domicile/ordinateur/forfaits/urgence/" onClick={closeMenu}>Forfaits Urgence</Link></li>
                  <li><Link to="/accueil/domicile/ordinateur/forfaits/formation/" onClick={closeMenu}>Formation</Link></li>
                </ul>
              </li>
              <li className="nav-item">
                <Link
                  to="/blog"
                  className={`nav-link ${isActive('/blog') ? 'active' : ''}`}
                  onClick={closeMenu}
                >
                  Blog
                </Link>
              </li>
              <li
                className="nav-item dropdown"
                onMouseEnter={() => setIsOutilsOpen(true)}
                onMouseLeave={() => setIsOutilsOpen(false)}
              >
                <span className={`nav-link dropdown-toggle ${location.pathname.startsWith('/outils') ? 'active' : ''}`}>
                  Outils
                </span>
                <ul className="dropdown-menu" style={{ opacity: isOutilsOpen ? 1 : undefined, visibility: isOutilsOpen ? 'visible' : undefined, transform: isOutilsOpen ? 'translateY(0)' : undefined }}>
                  <li>
                    <Link to="/outils" onClick={closeMenu} style={{ fontWeight: '600', borderBottom: '1px solid #f3f4f6' }}>
                      Voir tous les outils →
                    </Link>
                  </li>
                  {outilsMenu.filter(section => section.items.length > 0).map((section) => (
                    <React.Fragment key={section.group}>
                      <li style={{ padding: '0.4rem 1rem 0.2rem', fontSize: '0.75rem', color: '#9ca3af', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.05em', cursor: 'default' }}>
                        {section.group}
                      </li>
                      {section.items.map((item) => (
                        <li key={item.href}>
                          <Link to={item.href} onClick={closeMenu}>{item.label}</Link>
                        </li>
                      ))}
                    </React.Fragment>
                  ))}
                </ul>
              </li>
              <li className="nav-item">
                <Link
                  to="/accueil/maxime-huet-technicien-en-depannage-informatique/"
                  className={`nav-link ${isActive('/accueil/maxime-huet-technicien-en-depannage-informatique/') ? 'active' : ''}`}
                  onClick={closeMenu}
                >
                  À Propos
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/contact"
                  className={`nav-link ${isActive('/contact') ? 'active' : ''}`}
                  onClick={closeMenu}
                >
                  Contact
                </Link>
              </li>
            </ul>
          </nav>

          <button 
            className={`menu-toggle ${isMenuOpen ? 'open' : ''}`}
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
